const ONE_WAY_ID = 1
const ROUND_TRIP_ID = 2
const MULTI_CITY_ID = 3

const ONE_WAY_SLUG = 'one-way'
const ROUND_TRIP_SLUG = 'round-trip'
const MULTI_CITY_SLUG = 'multi-city'

export const FLIGHT_TYPE = {
  [ONE_WAY_SLUG]: ONE_WAY_SLUG,
  [ROUND_TRIP_SLUG]: ROUND_TRIP_SLUG,
  [MULTI_CITY_SLUG]: MULTI_CITY_SLUG,
  slugById: {
    [ONE_WAY_ID]: ONE_WAY_SLUG,
    [ROUND_TRIP_ID]: ROUND_TRIP_SLUG,
    [MULTI_CITY_ID]: MULTI_CITY_SLUG,
  },
  nameBySlug: {
    [ONE_WAY_SLUG]: 'Solo ida',
    [ROUND_TRIP_SLUG]: 'Ida y vuelta',
    [MULTI_CITY_SLUG]: 'Multiples destinos',
  },
  nameById: {
    [ONE_WAY_ID]: ONE_WAY_SLUG,
    [ROUND_TRIP_ID]: ROUND_TRIP_SLUG,
    [MULTI_CITY_ID]: MULTI_CITY_SLUG,
  },
}

export const SERVICE_TYPE = {
  ONE_WAY: ONE_WAY_ID,
  ROUND_TRIP: ROUND_TRIP_ID,
  MULTI_CITY: MULTI_CITY_ID 
}

export const QUERY_SERVICE_TYPE = {
  [ONE_WAY_ID]: ONE_WAY_SLUG,
  [ROUND_TRIP_ID]: ROUND_TRIP_SLUG,
  [MULTI_CITY_ID]: MULTI_CITY_SLUG,
}


export const BAGGAGE_UNIT_TYPE = {
  0: 'KG',
  1: 'LB',
  2: 'Piece',
}


export const BAGGAGE = {
  'Checkin': 'checkin',
  'Hand': 'hand',
}

export const BAGGAGE_TYPE = {
  0: 'All',
  1: 'Checkin',
  2: 'Hand',
}

